/* eslint-disable */
export default class ObjectUtil {
  static propertiesLength(object) {
    let size = 0,
      key;
    for (key in object) {
      if (object.hasOwnProperty(key)) size++;
    }
    return size;
  }

  static sortArrayOfObject(array, field, order) {
    return array.sort((curr, next) => {
      const a = curr[field].toLowerCase();
      const b = next[field].toLowerCase();
      return a < b ? order : a > b ? order * -1 : 0;
    });
  }

  static deepFind(obj, path) {
    const paths = path.split('.');
    let current = obj;

    for (let i = 0; i < paths.length; ++i) {
      if (current[paths[i]] === undefined) {
        return undefined;
      }
      current = current[paths[i]];
    }
    return current;
  }
}
